<template>
  <v-container fluid fill-width class="ma-0 pa-0 ml-2 mt-2">
    <v-row class="pa-0 ma-0">
      <v-col cols="12" class="pa-0 ma-0">
        <v-container
          fluid
          fill-width
          class="ma-0 pa-2 pl-5 pt-5"
          style="background-color: white;"
        >
          <v-row
            v-for="(domain, di) in domains"
            :key="'dr-' + di"
            class="pa-0 ma-0 py-2"
            align="start"
            justify="center"
          >
            <v-col cols="12" class="pa-0 ma-0" align="start" justify="center">
              <img
                :src="'/images/' + domain + '-icon-128.png'"
                :title="domain"
                style="height:2.5em"
                align="center"
                @error="missingDomainFallback"
              />
              <span class="pl-2" style="font-size: 1.3rem;">{{ domain }}</span>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { missingDomainFallback } from '@/utils/helpers';

export default {
  name: 'Domains',
  components: {},
  props: {},
  data() {
    return {
      domains: [
        'Autonomic',
        'Billing',
        'Cardiac',
        'Cognitive',
        'Dataset',
        'Demographics',
        'Disability',
        'Disease Features',
        'General Disease Severity',
        'Genetic',
        'Hearing',
        'Laboratory',
        'Medical History',
        'Mental Health',
	'Motor',
        'Neuroimaging',
        'Nutrition',
        'Physical Performance',
        'Prescription',
        'Rx',
        'Sleep',
        'Treatment',
	'Vestibular',
	'Vision',
        'Vitals',
        'Missing Domain',
      ],
      missingDomainFallback: missingDomainFallback,
    };
  },
  computed: {},
  watch: {},
  async created() {},
  methods: {},
};
</script>

<style scoped></style>
